import { user_default_img } from "./settings";

/* ==================================================================
 *  base
 *  pc、sp、manage全てで読み込みたいjsを読み込む
 * ================================================================== */
/* =========================================================
 * サインアップ時に応援、お気に入り、メール登録経由のどれなのかを把握する
========================================================= */
$("body").on("click", ".jsSupport, .jsBookmark, .jsMailRegister", function () {
  let inflow_source = "";
  if ($(this).hasClass("jsSupport")) {
    inflow_source = "support";
  } else if ($(this).hasClass("jsBookmark")) {
    inflow_source = "bookmark";
  } else if ($(this).hasClass("jsMailRegister")) {
    inflow_source = "mail_register";
  }
  $("#jsInflowSource").val(inflow_source);
});
/* =========================================================
 * User画像がなかった場合にデフォルトの画像を表示
========================================================= */
// NOTE: jQuery 3.x で .error() が廃止されたため .on('error', ...) に変更
$(".jsUserImg").on("error", function () {
  $(this).attr("src", user_default_img);
});
